import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

type ImpersonateUserRequest = {
    targetUserId: string;
};

type ImpersonateUserResponse = {
    targetToken: string;
    adminReturnToken: string;
    targetEmail: string | null;
};

export async function startImpersonation(targetUserId: string): Promise<ImpersonateUserResponse> {
    const impersonateUserFn = httpsCallable<ImpersonateUserRequest, ImpersonateUserResponse>(functions, 'impersonateUser');
    const result = await impersonateUserFn({ targetUserId });
    return result.data;
}
